import { render, staticRenderFns } from "./lrheader.vue?vue&type=template&id=a55a148c&scoped=true"
import script from "./lrheader.vue?vue&type=script&lang=js"
export * from "./lrheader.vue?vue&type=script&lang=js"
import style0 from "./lrheader.vue?vue&type=style&index=0&id=a55a148c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_f33b182414a87044fb4ff91041025cb4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55a148c",
  null
  
)

export default component.exports